<template>
  <v-container class="max-width-sm">
    <v-list
      two-line
      class="mt-md-2"
    >
      <v-toolbar
        flat
      >
        <v-btn
          v-if="hasEleaveOrPaperLeave"
          icon
          to="/eleave/list"
        >
          <v-icon>{{ mdiArrowLeft }}</v-icon>
        </v-btn>
        <v-toolbar-title>
          {{ $t('eleave.SickForm') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-tabs
        v-model="tabIdx"
        @change="tabChanged"
      >
        <v-tab :disabled="isSearching">
          {{ $t('eleave.Sick.ReadyToUse') }}
        </v-tab>
        <v-tab :disabled="isSearching">
          {{ $t('eleave.Sick.Used') }}
        </v-tab>
      </v-tabs>

      <template v-for="(cert) in medicalCerts">
        <v-list-item
          :key="cert.keyNo"
          @click="viewDetail(cert)"
        >
          <v-list-item-content>
            <v-list-item-title>
              {{ formatDate(cert.startSickDate) }} ~ {{ formatDate(cert.leaveToDate) }}
              <span v-if="cert.isNeedAccompaniment && bdrhStaff.docNum === cert.accompanyingPersonIdCardNum">
                ( {{ $t('eLeave.accompany') }} )
              </span>
            </v-list-item-title>
            <v-list-item-subtitle v-if="cert.isStayAtHome">
              {{ $t('eleave.StayAtHome') }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="cert.isStayAtHospital">
              {{ $t('eleave.StayInHospital') }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="cert.isNoNeedToStayAtHome">
              {{ $t('eleave.DontNeedStayInHome') }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="cert.isNeedTreatment">
              {{ $t('eleave.NeedTreatment') }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="cert.isRehabilitationAfterTreatment">
              {{ $t('eleave.AfterHospital', [cert.rehabilitationDaysAfterTreatment]) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        <!--
        <v-list-item-action>
          <v-list-item-action-text>26hrs</v-list-item-action-text>
        </v-list-item-action>
        -->
        </v-list-item>
      </template>

      <div class="grey--text text-center py-4">
        -- {{ $t('eleave.Sick.Statement.OnlyOneMonth') }} --
      </div>
    </v-list>
  </v-container>
</template>

<script>

import { sickLeaveModule, bdrhStaffModule } from '../../store/moduleName'
import { formatSSMDate, momentWithHyphen } from '../../utils/datetimeUtil'
import sickLeaveApi from '@/api/leave/sickLeave'
import sickLeaveVuex from '../../store/modules/leave/sickLeave'
import bdrhStaffVuex from '../../store/modules/hr/bdrhStaff'
import store from '../../store'
import constant from '@/constant/constant'
import { mapState } from 'vuex'
import { mdiArrowLeft } from '@mdi/js'

if (!store.state[sickLeaveModule]) store.registerModule(sickLeaveModule, sickLeaveVuex)
if (!store.state[bdrhStaffModule]) store.registerModule(bdrhStaffModule, bdrhStaffVuex)

export default {
  components: {
  },
  data: function () {
    return {
      mdiArrowLeft: mdiArrowLeft,
      isSearching: false,
      hasEleaveOrPaperLeave: this.$perServices.hasServices([constant.PER_SERVICES.ELEAVE, constant.PER_SERVICES.PAPER_LEAVE])
    }
  },
  computed: {
    ...mapState({
      bdrhStaff: state => state[bdrhStaffModule].info,
      medicalCerts: state => state[sickLeaveModule].medicalCerts
    }),
    tabIdx: {
      get () {
        return this.$store.state[sickLeaveModule].tabIdx
      },
      set (value) {
        this.$store.commit(sickLeaveModule + '/updateTabIdx', value)
      }
    }
  },
  created () {
    this.$store.dispatch(bdrhStaffModule + '/getStaff')
    this.search()
  },
  methods: {
    formatDate: function (dateStr) {
      if (this.tabIdx === 0) {
        return formatSSMDate(dateStr)
      } else {
        return momentWithHyphen(dateStr).format('YYYY-MM-DD')
      }
    },
    viewDetail (cert) {
      //      console.log('cert : ' + JSON.stringify(cert))
      this.$store.commit(sickLeaveModule + '/updateCurrCert', cert)
      this.$router.push({ name: 'sickLeaveDetail' })
    },
    search () {
      this.isSearching = true
      this.$store.commit(sickLeaveModule + '/clearMedicalCerts')
      if (this.tabIdx === 1) {
        sickLeaveApi.findInfoBystaffCode(resp => {
          this.isSearching = false
          if (resp.status === 201 || resp.status === 200) {
            this.$store.commit(sickLeaveModule + '/updateMedicalCerts', resp.data)
          }
        })
      } else {
        sickLeaveApi.getInfoFromSSM(resp => {
          this.isSearching = false
          if (resp.status === 201 || resp.status === 200) {
            this.$store.commit(sickLeaveModule + '/updateMedicalCerts', resp.data)
          }
        })
      }
    },
    tabChanged (number) {
      this.search()
    }
  }
}
</script>
